import { homeTrustMetrics } from '@/mocks/home';

export default function TrustBar() {
  return (
    <section className="relative w-full bg-background-50 -mt-14 z-20">
      <div className="w-full px-4 md:px-8">
        <div className="rounded-lg border border-background-200 bg-background-100 px-5 md:px-8 py-7 md:py-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {homeTrustMetrics.map((metric, index) => (
              <div
                key={metric.id}
                className={`flex flex-col ${
                  index !== homeTrustMetrics.length - 1 ? 'lg:border-r lg:border-background-300' : ''
                }`}
              >
                <span className="font-heading text-3xl md:text-4xl font-bold text-primary-600">{metric.value}</span>
                <span className="mt-2 text-sm font-medium text-foreground-900">{metric.label}</span>
                <span className="mt-1 text-xs leading-relaxed text-foreground-500">{metric.note}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}